import React, {FC} from 'react';

import {
  IntegrationTypeCategoriesEnum,
  IntegrationTypeModel,
} from '../../../../../models/api/integrationTypesModel';
import {FrameCard, FrameCardProps} from './frameCard';
import {FrameCardName} from './frameCardName';
import {IntegrationFrameCardAvatar} from './integrationFrameCardAvatar';
import {IntegrationFrameCardCategory} from './integrationFrameCardCategory';

/*
 * Props.
 */

interface IntegrationTypeFrameCardProps extends FrameCardProps {
  host: string;
  integrationType: IntegrationTypeModel;
}

/*
 * Component.
 */

export const IntegrationTypeFrameCard: FC<IntegrationTypeFrameCardProps> = (props) => {
  const {host, integrationType} = props;
  const category = integrationType.categories[0] || IntegrationTypeCategoriesEnum.ESSENTIALS;
  const integrationIconsUrl = `${host}/api/1/integration_types/${integrationType.id}/public/icons/`;

  return (
    <FrameCard {...props}>
      <IntegrationFrameCardAvatar integrationIconsUrl={integrationIconsUrl} />
      <FrameCardName>{integrationType.name}</FrameCardName>
      <IntegrationFrameCardCategory category={category} />
    </FrameCard>
  );
};
